/**
 * Shown in place of the map when it cannot be displayed. The side panel keeps working.
 */
import type { SiteMapCanvasProps } from './siteMapCanvasPort';

interface MapUnavailableProps {
  readonly message?: string;
}

export function MapUnavailable({ message }: MapUnavailableProps): JSX.Element {
  return (
    <div className="site-map-unavailable" role="alert">
      <p className="site-map-unavailable__title">The map could not be shown</p>
      <p className="site-map-unavailable__text">
        {message ? `${message}. ` : ''}The site list next to the map still works.
      </p>
    </div>
  );
}

/** Same props as the real canvas, so it can stand in for it when the chunk fails to load. */
export function MapUnavailableCanvas(_props: SiteMapCanvasProps): JSX.Element {
  return <MapUnavailable message="The map component failed to load" />;
}
